var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowSquareLeftPink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5001 18.9584H7.50008C2.97508 18.9584 1.04175 17.025 1.04175 12.5V7.50002C1.04175 2.97502 2.97508 1.04169 7.50008 1.04169H12.5001C17.0251 1.04169 18.9584 2.97502 18.9584 7.50002V12.5C18.9584 17.025 17.0251 18.9584 12.5001 18.9584ZM7.50008 2.29169C3.65841 2.29169 2.29175 3.65835 2.29175 7.50002V12.5C2.29175 16.3417 3.65841 17.7084 7.50008 17.7084H12.5001C16.3417 17.7084 17.7084 16.3417 17.7084 12.5V7.50002C17.7084 3.65835 16.3417 2.29169 12.5001 2.29169H7.50008Z",
    fill: "#FD4370"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0499 13.5667C10.8916 13.5667 10.7333 13.5083 10.6083 13.3833L7.6666 10.4417C7.42493 10.2 7.42493 9.80001 7.6666 9.55834L10.6083 6.61667C10.8499 6.37501 11.2499 6.37501 11.4916 6.61667C11.7333 6.85834 11.7333 7.25834 11.4916 7.50001L8.9916 10L11.4916 12.5C11.7333 12.7417 11.7333 13.1417 11.4916 13.3833C11.3749 13.5083 11.2166 13.5667 11.0499 13.5667Z",
    fill: "#FD4370"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowSquareLeftPink);
export default __webpack_public_path__ + "static/media/arrow-square-left-pink.1a53dccf26c33f47010d246cb64a397e.svg";
export { ForwardRef as ReactComponent };